import { DecimalPipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

/**
 * Formats a cargo amount (gross/net weight, volume, quantity, weight in vacuum) like the `number` pipe,
 * but renders null and 0 as empty. An amount that was not declared is stored as 0 in some places,
 * and 0 must not be shown as if it were a declared value. Grids display the empty result as "-"
 * (see GridEmptyCellDirective).
 */
@Pipe({
    name: 'cargoAmount',
    standalone: false
})
export class CargoAmountPipe implements PipeTransform {
    private decimalPipe: DecimalPipe;

    // Same default locale as the built-in `number` pipe: the app's LOCALE_ID, used when no locale argument is given.
    constructor(@Inject(LOCALE_ID) locale: string) {
        this.decimalPipe = new DecimalPipe(locale);
    }

    transform(value: number | string | null | undefined, digitsInfo?: string, locale?: string): string | null {
        if (value === null || value === undefined || value === '' || Number(value) === 0) {
            return null;
        }
        return this.decimalPipe.transform(value, digitsInfo, locale);
    }
}
